import React, { useRef, useState, useEffect, Fragment, useCallback } from 'react';
import { dBConn } from '../../ApiCenter/API_GET';
import './CastingHistory.css';

const CastingHistory = ({data}) => {
    
    const [levels, setLevels] = useState(["Actor", "Project", "Batch", "Script"]);
    const expandedRef = useRef({});
    const levelDefault = useRef(1);
    const loadedSamples = useRef({});
    const samplesPlaylist = useRef([]);
    const currentId = useRef(0);
    const noMoreSamples = useRef(false);
    const [nextPrevStatus, setNextPrevStatus] = useState(0); //0 prev and next deactivated, 1 next active, 2 prev and next active, -1 prev active
    const [loading, setLoading] = useState(false);
    const [src, setSrc] = useState('');
    const selectedType = useRef(null);
    const [noSamples, setNoSamples] = useState(false);
    const playSelId = useRef('');
    
    const playSample = useCallback((next, actorId, type, id, forceLoad) => {  
        
        const setNextPrev = () => {
            if(currentId.current === 0 && loadedSamples.current.offset === 0) {
                setNextPrevStatus(samplesPlaylist.current.length > currentId.current + 1 ? 1 : 0);
            } else if(currentId.current === samplesPlaylist.current.length - 1 && noMoreSamples.current) {
                setNextPrevStatus(currentId.current > 0 || loadedSamples.current.offset > 0 ? -1 : 0);
            } else {
                setNextPrevStatus(2);
            }      
        }
        
        const loadSamples = (offset) => { 
            if(offset) loadedSamples.current.offset += 10;
            setLoading(true);
            dBConn.post('getRecurringTargetSamples', loadedSamples.current).then((result) => {
                noMoreSamples.current = result.length < 10;
                if(result.length === 0) {
                    if(loadedSamples.current.offset === 0) {
                        samplesPlaylist.current = [];
                        setSrc('');
                        setNoSamples(true);
                    };
                    if(offset) loadedSamples.current.offset -= 10;
                    setLoading(false);
                    setNextPrev();
                    return;
                }
                const selId = loadedSamples.current;
                playSelId.current = selId.actorId + '|' + selId.targetId.type + '|' + selId.targetId.id;
                samplesPlaylist.current = result;
                currentId.current = 0;
                playSample(0);
                setNoSamples(false);
                setNextPrev();
            });
        }  
        
        const loadSrc = () => {
            const sample = samplesPlaylist.current?.[currentId.current];
            if (sample) {
                const type = selectedType.current && sample.hasOwnProperty(selectedType.current) ? selectedType.current :  Object.keys(sample)?.[0];
                let link = sample[type]?.link;                
                if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1"){
                    link = link.replace('https://audiomate.s3.eu-west-1.amazonaws.com', '')
                }
                selectedType.current = type;
                setSrc(link);
                setLoading(false);
            } else {
                currentId.current--;
            }
            setNextPrev();
        }
        
        if(forceLoad) {
            loadSamples();
            return;
        }
        
        if(next === 0 && !actorId && !type && !id) {
            loadSrc();
            return;
        }
        
        if(Object.keys(loadedSamples.current).length === 0) {
            if(!actorId) actorId = Object.keys(data.data)?.[0];
            if(!type) type = Object.values(data.data)?.[0]?.type;
            if(!id) id = Object.values(data.data)?.[0]?.id;  
            loadedSamples.current = {charId: data.header.id, actorId: parseInt(actorId), targetId: {type, id}, offset: 0};
            loadSamples();
            return;
        }
        
        let newData = false;
        if(next === 0 && loadedSamples.current.actorId !== parseInt(actorId)) {
            loadedSamples.current.actorId = parseInt(actorId);
            newData = true;
        };
        if(next === 0 && loadedSamples.current.targetId.type !== type) {
            loadedSamples.current.targetId.type = type;
            newData = true;
        };
        if(next === 0 && loadedSamples.current.targetId.id !== id) {
            loadedSamples.current.targetId.id = id;
            newData = true;
        };
        
        let offset = false;
        
        const nextId = currentId.current + next;
        
        if(newData) {
            noMoreSamples.current = false;
            loadedSamples.current.offset = 0;
        } else if(nextId < 0 && loadedSamples.current.offset === 0) {
            return;
        } else if(nextId < 0 && loadedSamples.current.offset > 0) {
            currentId.current = 9;
            loadedSamples.current.offset -= 10;
        } else if(nextId === (samplesPlaylist.current.length) && noMoreSamples.current) {
            return;
        } else if(nextId < 10) {
            currentId.current = nextId;
        } else {
            offset = true;
        }
        
        if(offset || newData) {
            loadSamples(offset);
        } else {
            loadSrc();
        }
        
    }, [data.data, data.header.id])
    
    const expandLevel = (level) => {
        levelDefault.current = level;
        if(!data.header?.id || !expandedRef.current.hasOwnProperty(data.header.id)) return;
        Object.entries(expandedRef.current[data.header.id]).forEach(([k,v]) => {
            Object.values(v).forEach(v => {
                const newVal = parseInt(k) < level;
                if(!newVal && parseInt(k) > level && v[1]) { v[1] = null; }
                if(v[1]) { v[1](newVal); } else { v[0] = newVal; }
            });     
        })        
    }
    
    if(data.header?.id && !expandedRef.current.hasOwnProperty(data.header.id)) {
        expandedRef.current[data.header.id] = {};
    }
    
    useEffect(() => {
        loadedSamples.current = {};
        samplesPlaylist.current = [];
        currentId.current = 0;
        noMoreSamples.current = false;
        playSelId.current = '';
        setNoSamples(false);
        setNextPrevStatus(0);
        setLoading(false);
        setSrc('');
    }, [data])
     
    return (
        <div className='casting-history-container'>
            <div key='header' className={'casting-history-header'}>{data.header?.name}</div>
            <div key='buttons' className='casting-history-buttons'>
                {levels.map((l, idx) => 
                    <button 
                        key={idx} 
                        title={`Display ${l} level`}
                        className={`casting-history-buttons ${l ?? ''}`} 
                        onClick={() => expandLevel(idx)}>
                        {l?.[0]}
                    </button>
                )}  
                <PlayTemplate src={src} loading={loading} playSamples={playSample} nextPrevStatus={nextPrevStatus} noSamples={noSamples}/>  
                {selectedType.current && Object.keys(samplesPlaylist.current?.[currentId.current] ?? {}).length > 1 &&
                    <select key='filetype' className='casting-history-select' onChange={(e) => {
                        selectedType.current = e.target.value;
                        playSample(0);
                    }}>
                        {Object.keys(samplesPlaylist.current?.[currentId.current] ?? {}).map((k) => 
                                <option key={k} value={k}>{k}</option>
                        )}
                    </select>
                }
            </div>
            <div key='table' className='casting-history-ul-container'>
                <ul key={data.header?.id} className={'casting-history-main-ul'}>
                    {Object.entries(data.data).map(([k, v]) => {
                        const key = k;
                        const expandeRefNode = expandedRef.current?.[data.header?.id];
                        return <CastingLi 
                                    key={key} 
                                    liKey={key} 
                                    nodeKey={key} 
                                    data={v} 
                                    firstNode={true} 
                                    level={0} 
                                    levelDefault={levelDefault} 
                                    expandeRefNode={expandeRefNode}
                                    playSamples={playSample}
                                    playSelId={playSelId}/>
                    })}        
                </ul>
            </div>
        </div>
    )

};

const CastingLi = ({liKey, nodeKey, data, firstNode, level, levelDefault, expandeRefNode, playSamples, playSelId}) => {
    
    const [expanded, setExpanded] = useState(expandeRefNode?.[level]?.[liKey]?.[0] ?? level < levelDefault.current);
    const playSelected = (nodeKey + '|' + data.type + '|' + data.id) === playSelId.current;
    
    useEffect(() => {
        if(!expandeRefNode) return;
        if(!expandeRefNode.hasOwnProperty(level)) expandeRefNode[level] = {};
        expandeRefNode[level][liKey] = [expanded, setExpanded];
        
        return () => expandeRefNode[level][liKey][1] = null; //Delete setExpanded but keep state
    }, [expanded, expandeRefNode, nodeKey, liKey, level, firstNode]);
    
    return (
        <li key={liKey}>
            <div style={{position: 'relative'}}>
                <div className={`casting-history-node ${data.type} ${!firstNode ? 'node' : ''} ${playSelected ? 'selected' : ''}`} key='name'>
                    {data.child && 
                        <div key='expand' className={`casting-history-expand ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(p => !p)}>▶</div>
                    }
                    <div key='icon' className={`casting-history-icon ${data.type}`}>{data.type[0]}</div>
                    {data.name}
                    <button 
                        key='play'
                        className={`btn btn-outline-primary btn-sm casting-history-play`} 
                        onClick={() => playSamples?.(0, nodeKey, data.type, data.id) } 
                        title={`Play samples from this ${data.type}`}>
                            <i className="bi bi-play-circle target"/>
                    </button>
                </div>
            </div>
            {expanded && data.child && 
                <ul className='casting-history' key='list'>
                    {Object.entries(data.child).map(([k, v]) => {
                        const key = nodeKey + '|' + v.type[0] + k;
                        return <CastingLi 
                                    key={key} 
                                    liKey={key} 
                                    nodeKey={nodeKey} 
                                    data={v} 
                                    firstNode={false} 
                                    level={level + 1} 
                                    levelDefault={levelDefault} 
                                    expandeRefNode={expandeRefNode} 
                                    playSamples={playSamples}
                                    playSelId={playSelId}/>
                    })}
                </ul>
            }
        </li>
    ) 
       
}

const PlayTemplate = ({src, loading, playSamples, nextPrevStatus, noSamples}) => {

    const formatTime = useCallback((time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds < 10 ? "0" + seconds : seconds}`;
    },[]);
    
    const playerRef = useRef(null);
    const trackerBarRef = useRef(null);
    const [counter, setCounter] = useState(`${formatTime(0)}/${formatTime(0)}`);
    const [playing, setPlaying] = useState(false);
    const [continuous, setContinuous] = useState(true);
    const duration = useRef(0);
    const [seeking, setSeeking] = useState(false);
    const [smallScreen, setSmallScreen] = useState(false);
    const errorTry = useRef(false);
    const [errorPlaying, setErrorPlaying] = useState(false);
        
    const handleTimeUpdate = () => {
        const currentTime = playerRef.current?.currentTime ?? 0;
        trackerBarRef.current.style.width = Math.round(100 * (currentTime/duration.current)) + '%';
        setCounter(`${formatTime(currentTime)}/${formatTime(duration.current)}`);
    }
    
    const handlePlay = async () => {
        if(duration.current === 0 || src === '') {
            playSamples?.(1);
            return;
        }
        setPlaying(p => !p);     
    }
    
    useEffect(() => {
        if(playing) {
            playerRef.current?.play();
        } else {
            playerRef.current?.pause();
            //playerRef.current.currentTime = 0;
        }
    }, [playing])
    
    useEffect(() => {
        if(playerRef.current) {
            playerRef.current?.pause();
            playerRef.current.currentTime = 0;
        }
    }, [loading])
    
    useEffect(() => {    
        const audio = playerRef.current;
        if (!audio) return; 
           
        setPlaying(false);
        duration.current = 0;
        audio.currentTime = 0;
        trackerBarRef.current.style.width = '0%';
        if(src !== '') setSeeking(true);
            
        const handleLoadedMetadata = (e) => { 
            errorTry.current = false;
            duration.current = isNaN(playerRef.current?.duration) ? 0 : playerRef.current.duration;
            const counters = formatTime(0) + '/' + formatTime(duration.current);
            trackerBarRef.current.style.width = '0%';
            setCounter(counters);
            setPlaying(true);
        };  
        audio.addEventListener('loadedmetadata', handleLoadedMetadata);
        const handleCanPlay = (e) => { setSeeking(false) };
        audio.addEventListener('canplay', handleCanPlay);
        return () => {
            audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
            audio.removeEventListener('canplay', handleCanPlay);
        };     
    }, [formatTime, src])

    const seekAudio = (e) => {
        if(!playerRef.current) return;
        setSeeking(true);
        const seekPosition = duration.current * (e.nativeEvent.offsetX/e.currentTarget.offsetWidth);
        playerRef.current.currentTime = seekPosition;
        if(!playing && continuous) setPlaying(true);
    }
    
    const handleOnEnd = () => {   
        setPlaying(false);
        playerRef.current.currentTime = 0;
        if(continuous) playSamples?.(1);
    }
    
    const playNextPrev = (v) => {
        if(v === -1 && ![-1, 2].includes(nextPrevStatus)) {
            playerRef.current.currentTime = 0;
            setPlaying(true);
        } else {
            playSamples?.(v);
        }    
    }
    
    const handleError = (e) => {   
        if(src === '') return;
        if(!errorTry.current) {
            errorTry.current = true;
            playSamples?.(0, false, false, false, true);
        } else {
            setErrorPlaying(true);
            errorTry.current = false;
        }
    }
    
    const playerContainerRef = useRef(null);
    
    useEffect(() => {
        if(!playerContainerRef.current) return;
        
        const player = playerContainerRef.current;     
        const observer = new ResizeObserver(([entry]) => {
            const width = entry.contentRect.width;
            setSmallScreen(width < 240);
        });   
        observer.observe(player);
      
        return () => { observer.disconnect() };
      }, []);

    return (
        <Fragment>
            <audio ref={playerRef} src={src} preload="auto" type="audio/mpeg"
                onTimeUpdate={handleTimeUpdate}
                onEnded={handleOnEnd}
                onError={handleError}
            />
            <div /*id='customAudioPlayer'*/ ref={playerContainerRef} key='playercontainer' className={`casting-history-audio`}>
                <div key='player' className='casting-history-player'>
                    <div id='play' key='play' 
                        className={`casting-history-playButton ${(loading || seeking) && !errorPlaying ? 'loading' : noSamples || errorPlaying ? 'deactivated' : playing ? 'playing' : ''}`}
                        onClick={handlePlay}>
                            {(loading || seeking) && !errorPlaying ? '' : !playing ? '▶' : '⏹'}     
                    </div> 
                    <div id='trackerContainer' key='track' className={`casting-history-trackerContainer`} style={{display: noSamples || errorPlaying ? 'none' : ''}} onClick={seekAudio}>
                        <div key='tracker' className='casting-history-tracker'>
                            <div ref={trackerBarRef} key='bar' className='casting-history-trackerBar'/>
                        </div>
                    </div>
                    {(noSamples || errorPlaying) && 
                        <span key='msg' className='casting-history-audio-msg'>
                            {noSamples ? "No samples available" : "Audio can't be played"}
                        </span>}
                    <span key='counter' className='counter' style={{display: noSamples || errorPlaying || smallScreen ? 'none' : '', fontSize: '0.85em'}}>{counter}</span>
                    <div key='navigation' style={{display: 'flex'}}>
                        <div id='prev' key='prev' className={`casting-history-playButton ${!playing && (playerRef.current?.currentTime ?? 0) === 0 && ![-1, 2].includes(nextPrevStatus) ? 'deactivated' : ''}`}
                            title='Play previous sample'
                            onClick={() => playNextPrev(-1)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M6 5h2v14H6V5zM9.5 12L18 5v14l-8.5-7z" />
                            </svg>
                        </div> 
                        <div id='next' key='next' className={`casting-history-playButton ${![1, 2].includes(nextPrevStatus) ? 'deactivated' : ''}`} 
                            title='Play next sample'
                            onClick={() => playNextPrev(1)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
                                <path d="M16 5h2v14h-2V5zM6 5v14l8.5-7L6 5z" />
                            </svg>
                        </div> 
                        <div id='continuous' key='continuous' className={`casting-history-playButton`} 
                            style={{marginLeft: '4px'}} 
                            title='Continuous playback'
                            onClick={() => setContinuous(p => !p)}>
                            <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <path d="M18 4L21 7M21 7L18 10M21 7H7C4.79086 7 3 8.79086 3 11M6 20L3 17M3 17L6 14M3 17H17C19.2091 17 21 15.2091 21 13" stroke={continuous ? '#00ad17' : `currentColor`} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                            </svg>
                        </div>
                    </div>
                </div>
            </div> 
        </Fragment>
    )

}

export default CastingHistory;